import script from "./variation_text.vue?vue&type=script&setup=true&lang=js"
export * from "./variation_text.vue?vue&type=script&setup=true&lang=js"

import "./variation_text.vue?vue&type=style&index=0&id=9871087a&scoped=true&lang=css"

import exportComponent from "/var/www/html/obelle-form-order/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9871087a"]])

export default __exports__